export const blockIconsBusinessandpaymentsAccountBalanceWalletNew = (
	<span className='material-symbols-outlined'>account_balance_wallet</span>
);
